export const INITIAL_USERS = [];
export const INITIAL_GROUPS = [];
export const INITIAL_GAMES = [];
export const EMOJI_OPTIONS = [
  // Masculinos
  '👨🏻', '👱🏻‍♂️', '🧑🏽', '🧔🏻‍♂️', '👨🏿', '👱🏼',
  // Femininos
  '👩🏻', '👱🏻‍♀️', '👩🏽', '👩🏿', '👩🏽‍🦰', '🧕',
  // Outros
  '🦁', '🐯', '🦅', '🦈', '🧤', '⚽', '🏃🏻', '🥷', '🤖', '👽',
];
/** Série A Brasileirão 2026 — fonte: ESPN API bra.1 */
export const SERIE_A_TEAMS = [
  'Athletico-PR', 'Atlético-MG', 'Bahia', 'Botafogo',
  'Corinthians', 'Coritiba', 'Cruzeiro', 'Flamengo',
  'Fluminense', 'Fortaleza', 'Grêmio', 'Internacional',
  'Mirassol', 'Palmeiras', 'Bragantino', 'Remo',
  'Santos', 'São Paulo', 'Vasco', 'Vitória',
];

/** Série B Brasileirão 2026 — fonte: ESPN API bra.2 */
export const SERIE_B_TEAMS = [
  'América-MG', 'Athletic', 'Atlético-GO', 'Avaí',
  'Botafogo-SP', 'CRB', 'Ceará', 'Chapecoense',
  'Criciúma', 'Cuiabá', 'Goiás', 'Juventude',
  'Londrina', 'Novorizontino', 'Náutico', 'Operário-PR',
  'Ponte Preta', 'Sport', 'São Bernardo', 'Vila Nova',
];

export const TEAMS_OPTIONS = [
  'Sem Time',
  ...SERIE_A_TEAMS,
  ...SERIE_B_TEAMS,
];